import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { AppContent } from './components/AppContent';
import { providerConfig } from './config/auth0';
import './styles/globals.css';

function App() {
  return (
    <Auth0Provider {...providerConfig}>
      <Router>
        <div className="min-h-screen bg-white">
          <AppContent />
        </div>
      </Router>
    </Auth0Provider>
  );
}

export default App;
